import React from 'react';
import SharedBanner from '../../Shared/SharedBanner/SharedBanner';
import image from '../../../Assets/Backgrounds/jobsBg.webp';
import StyledButton from '../../Shared/StyledButton/StyledButton';
function Banner(){
    return(
        <>
        <SharedBanner 
        title="Let's fulfill dreams together"
        desc="We’re out to transform the way entrepreneurs build their brands and provide value to the world – One task at a time."
        backgroundImage={image}
        styles="noshade"
        other={<StyledButton btn="Join the team" styles="nobg-btn"/>}
        other2={<StyledButton btn="Careers" styles="transparent-btn" />}

        />
        </>
    )
};
export default Banner ;